import 'semantic-ui-css/semantic.min.css'
import { React } from 'react';
import {
  useLoaderData ,
  useNavigate
} from "react-router-dom";
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"
import classNames from 'classnames';
import styles from './css/Item.css';
//import data from './' + process.env.PUBLIC_URL + '/data/epublicaties.json'
import epubLogo from './assets/epub-logo.png'
import { Card , Label , Image , Icon , Popup , Item} from 'semantic-ui-react';
//const pub = process.env.PUBLIC_URL
import './translations/i18n';
import { useTranslation  } from 'react-i18next';
import useWindowDimensions from './useWindowDimensions'


const icons = {
    E_BOOK : 'book',
    E_TIJDSCHRIFT : 'address book',
    WEBSITE : 'globe',
    E_DATABANK : 'computer',
    E_HANDBOEK : 'book',
    KRANT : 'newspaper',
    E_PLATFORM : 'keyboard',
    E_DOCUMENT : 'file',
    MULTIMEDIA : 'play'
}
const pjson = require('../package.json')
const base = (!!pjson.homepage) ? pjson.homepage : '/'

const  FeedItem = ({ item }) => {
    const navigate = useNavigate()
    const link = base + 'detail/' + item.id
    const {height, width} = useWindowDimensions();

    const { t , i18n } = useTranslation();
        return (
        <Item
        onClick={() => navigate(link) }
            className={classNames(
                styles.itemCard,
            )}
            style={{
                margin : '3px' ,
                cursor : 'pointer'
            }}
        fluid
        key={item.id}
        >
        <Item.Image size='tiny' src={!!item.afbeelding ? item.afbeelding : epubLogo} />

            <Item.Content>
            
                <Item.Header>{item.titel}</Item.Header>
        <Item.Description>
        {item.uitgelicht && (
            <Label
                icon='hand point right outline'
                className={styles.label}
                content={t('uitgelicht')}
                color='teal'
            />
        )}
        </Item.Description>
        <Item.Extra>
            {item.uitgavenvorm.map(( k , v) => {
                return <Popup 
                    key={v}
                    content={t(`taxonomieItems.${k}`)} trigger={
                        <Label
                        icon={icons[k]}
                        className={styles.label}
                        content={t(`taxonomieItems.${k}`)}
                        color='blue'
                    />
                
            
            } />
            })
            }
        </Item.Extra>
        
        </Item.Content>
    </Item>

    );

}

export default FeedItem;